module.exports = __webpack_public_path__ + "static/Google_Material_You_cover-253a5fbb16d388620c31382061a6199a.png";